import React, { useEffect, useState } from "react";
import { SessionTimer } from "./SessionTimer";
import SessionWarningBanner from "./SessionWarningBanner";
import { getIdleLimitMs, getWarnBeforeMs } from "../../utils/sessionConfig";
import { auth } from "../../pages/api/axios";

function isAuthenticated() {
    return !!window.localStorage.getItem("authUser");
}

const SessionTimeoutManager = () => {
    const [authed, setAuthed] = useState(isAuthenticated());
    const [warning, setWarning] = useState(null); // null or { remainingMs }

    // Track login/logout in THIS tab (rdc-auth-changed, dispatched by the auth saga)
    // and in OTHER tabs (the 'storage' event, which never fires in the writing tab).
    useEffect(() => {
        const recompute = () => setAuthed(isAuthenticated());
        const onStorage = (e) => {
            if (e.key === "authUser") recompute();
        };
        window.addEventListener("storage", onStorage);
        window.addEventListener("rdc-auth-changed", recompute);
        recompute(); // in case login completed between render and this effect
        return () => {
            window.removeEventListener("storage", onStorage);
            window.removeEventListener("rdc-auth-changed", recompute);
        };
    }, []);

    useEffect(() => {
        if (!authed) return undefined;

        const timer = new SessionTimer({
            idleLimitMs: getIdleLimitMs(),
            warnBeforeMs: getWarnBeforeMs(),
            onChange: (state) => {
                setWarning(state.phase === "warning" ? { remainingMs: state.remainingMs } : null);
            },
            onExpire: () => {
                setWarning(null);
                auth.endSession("session_timeout");
            },
        });
        timer.start();
        return () => {
            timer.destroy();
            setWarning(null);
        };
    }, [authed]);

    if (!authed || !warning) return null;

    return <SessionWarningBanner remainingMs={warning.remainingMs} />;
};

export default SessionTimeoutManager;
